











































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import '../../assets/css/Modal.scss';
import { ApiRequest, Document } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { LoaderEvent, ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { DateUtils } from '../../util/dateUtils';
import { ApiResponse, DriverProfile, UploadFileResponse } from '../../types/response';
import { TransporterLoc } from '@/types/entity';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
declare var google: any;

@Component({
    mixins: [validationMixin],
    components: {
            ModelSelect,
    },
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            licenceNumber: '',
            licenceState: '',
            expireDate: '',
            birthDate: '',
            timezone: '',
            locationId: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
            documents: ProfileFormData.driverDocuments,
            locationOptions: [],
        };
    },
    validations: {
        fullName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) =>
                /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phone),
        },
        email: {
            required,
            email,
        },
        licenceNumber: {
            required,
        },
        licenceState: {
            required,
        },
        timezone: {
            required,
        },
        expireDate: {
            required,
        },
        birthDate: {
            required,
        },
        address: {
            fullAddress: {
                required,
            },
            locality: {},
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    },
})

export default class UpdateDriverModal extends Vue {
    private locationGoogleAddress: any;
    private show = false;
    private driver: any;
    private locations: TransporterLoc[] | undefined = [];
    private TimeZones = TimeZones;
    private showDeleteConfirmBox = false;
    private maxDate = new Date();
    private selectedDocument: Document = {} as any;
    public mounted() {
        this.getGoogleAddress();
        this.getDriver();
        this.getLocation();
        this.maxDate.setFullYear(this.maxDate.getFullYear() - 23);
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('driverAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }
    private async setDocument($event: any, document: Document, index: number) {
        const filename: string = $event.target.files[0].name.toLowerCase();
        if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
            filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
            document.file = $event.target.files[0];
            document.filename = $event.target.files[0].name;
        } else {
            const toastEvent: ToastEvent = {
                message: 'File types should be PDF, JPEG, PNG',
                title: 'Invalid file format.',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            const inputName = `file-input${index}`;
            const element = this.$refs[inputName] as any;
            element[0].reset();
        }
    }
    private async removeDocument(document: Document) {
        if (document.resourceId) {
            const response = await ObjectFactory.getFileService().
                deleteFile(document.resourceId, this.$store.state.serverUrl);
            if (response.success) {
                document.resourceId = '';
            }
        }
        document.file = undefined;
        document.filename = '';
        this.updateDriver();
        this.showDeleteConfirmBox = false;
    }
    private async saveDocuments() {
        const promises: Array<Promise<ApiResponse<UploadFileResponse>>> = [];
        const indexes: number[] = [];
        let index = 0;
        this.$data.documents.forEach((document: Document) => {
            if (document.file && !document.resourceId) {
                const formData = new FormData();
                formData.append('file', document.file as any);
                indexes.push(index);
                promises.push(ObjectFactory.getFileService()
                    .uploadFile(formData, this.$store.state.serverUrl));
            }
            index++;
        });
        if (promises.length >= 1) {
            const loaderEvent: LoaderEvent = {
                show: true,
                message: 'Uploading',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
            Promise.all(promises).then((uploadDocumentResponses) => {
                let indexTemp = 0;
                uploadDocumentResponses.forEach((uploadDocumentResponse) => {
                    const documentIndex = indexes[indexTemp];
                    const document = this.$data.documents[documentIndex];
                    delete document.file;
                    if (uploadDocumentResponse.data) {
                        document.resourceId = uploadDocumentResponse.data.fileName;
                    }
                    indexTemp++;
                });
            }).catch(() => {
                const toastEvent: ToastEvent = {
                    message: 'Failed to upload document',
                    title: 'Error!',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }).finally(() => {
                loaderEvent.show = false;
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_LOADER, loaderEvent);
                this.updateDriver();
            });
        } else {
            this.updateDriver();
        }
    }

    private async getLocation() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/location/list`,
                loaderEvent: {
                    show: true,
                },
            };
        const response = await iHttpService.get<TransporterLoc[]>(apiRequest);
        if (response.success && response.data) {
                this.$data.locationOptions = [];
                this.locations = response.data as any;
                response.data.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.branchName,
                };
                this.$data.locationOptions.push(option);
                });
            } else {
                CommonUtils.showError(response);
            }
    }

    /**
     * @author <Shraddha.K>
     * @description API - Returns driver locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of drivers
     * @returns List of driver lists
     * @throws InvalidRequestException if driver id is invalid
     */
    private async getDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const driverId = this.$route.params.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${driverId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<DriverProfile>(apiRequest);
        if (response.success && response.data) {
            this.driver = response.data;
            this.$data.fullName = response.data.fullname;
            this.$data.email = response.data.email;
            this.$data.phone = response.data.phone;
            this.$data.licenceNumber = response.data.licenceNo;
            this.$data.licenceState = response.data.licenceState;
            this.$data.expireDate = DateUtils.formatDate(response.data.expireYear, 'YYYY-MM-DD');
            this.$data.birthDate = response.data.birthDate;
            this.$data.iscertified = response.data.isCertified;
            this.$data.address = response.data.address;
            this.$data.locationId = response.data.locationId;
            this.$data.timezone = response.data.timezone;
            this.show = true;
            const formDocuments: Document[] = ProfileFormData.driverDocuments;
            if (response.data.documents) {
                response.data.documents.forEach((document: Document) => {
                    const objIndex = formDocuments.findIndex(((obj) =>
                            obj.name === document.name));
                    if (objIndex >= 0) {
                        formDocuments[objIndex].resourceId = document.resourceId;
                        formDocuments[objIndex].filename = document.filename;
                    }
                });
            }
            this.$data.documents = formDocuments;
        } else {
            CommonUtils.showError(response);
        }
    }

    /**
     * @author <shraddha.K>
     * @description - update driver
     * @param req {Request} - calls update driver API
     * @param res {Response} - Express Response - success result
     * @returns driver list
     * @throws InvalidRequestException if driver not found already exists
     */
    private async updateDriver() {
        const iHttpService = ObjectFactory.getHttpService();
        const driverId = this.$route.params.id;
        const updateDriverRequest: DriverProfile = {
          fullname: this.$data.fullName,
          phone: this.$data.phone,
          email: this.$data.email,
          expireYear: this.$data.expireDate,
          birthDate: this.$data.birthDate,
          licenceNo: this.$data.licenceNumber,
          licenceState: this.$data.licenceState,
          address: this.$data.address,
          documents: this.$data.documents,
          timezone: this.$data.timezone,
          locationId: this.$data.locationId,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/driver/${driverId}`,
            data: updateDriverRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<DriverProfile>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_UPDATE_DRIVER'),
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }


}
